// frontend/src/utils/tenantSlug.js
//
// Canonical tenant-name → URL slug. Used by every place that either generates
// or validates an `:orgName` / `:tenant` route param. Centralised here because
// historically the same transformation was duplicated 7+ times across the app
// with two incompatible variants, which broke navigation for any tenant whose
// name contained characters outside `[a-z0-9 -]` (e.g. apostrophes, accented
// letters): some callers stripped them, others kept them, and the URL the user
// landed on no longer matched what `OrganizationRoute` expected → `/unauthorized`.
//
// Rule: lowercase, collapse whitespace runs to `-`, drop everything that isn't
// `[a-z0-9-]`. Empty input yields `''` so callers can decide on a fallback.

export function tenantNameToSlug(name) {
  if (!name || typeof name !== 'string') return '';
  return name
    .toLowerCase()
    .replace(/\s+/g, '-')
    .replace(/[^a-z0-9-]/g, '');
}

export default tenantNameToSlug;
